/*
Usage: Accordion.js
---
import stickyContent from './lib/stickyContent'

// 例：600pxを超えたら出現。footer 付近や最下部では退避
stickyContent(
  'footer', // 非表示にする要素のクラス名
  'sticky', // スクロール時に付与するクラス名のサフィックス
  600       // スクロール開始位置の閾値(px)
);
*/

const stickyContent = (hideClass, suffix = "", scrollHeight = 600) => {
  const body = document.body;
  const getThreshold =
    typeof scrollHeight === "function" ? scrollHeight : () => scrollHeight;

  let ticking = false;
  let state = "off";
  let lastScrollY = window.scrollY || document.documentElement.scrollTop || 0;
  let lastDirection = "down";

  const applyState = (nextState, scrollY, readyThreshold) => {
    if (state === nextState) return;

    state = nextState;

    const standbyActive =
      state === "standby" || state === "ready" || state === "on";
    const readyActive = state === "ready" || state === "on";
    const onActive = state === "on";

    const standbyStable =
      standbyActive && (lastDirection === "down" || scrollY >= readyThreshold);

    body.classList.toggle(`--${suffix}-scroll-standby`, standbyStable);
    body.classList.toggle(`--${suffix}-scroll-ready`, readyActive);
    body.classList.toggle(`--${suffix}-scroll-on`, onActive);

    if (!onActive) {
      body.classList.remove(`--${suffix}-scroll-out`);
    }
  };

  const deriveState = (
    scrollY,
    standbyThreshold,
    readyThreshold,
    threshold,
  ) => {
    if (scrollY >= threshold) return "on";
    if (scrollY >= readyThreshold) return "ready";
    if (scrollY >= standbyThreshold) return "standby";
    return "off";
  };

  const evaluateScroll = () => {
    const threshold = Math.max(0, Math.round(getThreshold()));
    const standbyBuffer = Math.min(200, Math.round(threshold * 0.6));
    const readyBuffer = Math.max(
      40,
      Math.min(100, Math.round(threshold * 0.4)),
    );
    const standbyThreshold = Math.max(0, threshold - standbyBuffer);
    const readyThreshold = Math.max(0, threshold - readyBuffer);
    const scrollY = window.scrollY || document.documentElement.scrollTop || 0;

    const revertLimit = Math.min(readyThreshold, 80);
    let nextState = deriveState(
      scrollY,
      standbyThreshold,
      readyThreshold,
      threshold,
    );

    if (state === "on" && nextState !== "on" && scrollY > revertLimit) {
      nextState = "on";
    }

    applyState(nextState, scrollY, readyThreshold);

    if (scrollY > lastScrollY + 2) {
      lastDirection = "down";
    } else if (scrollY < lastScrollY - 2) {
      lastDirection = "up";
    }
    lastScrollY = scrollY;

    if (hideClass && state === "on") {
      const hideEl = document.querySelector(`.${hideClass}`);
      if (hideEl) {
        const { y, height } = hideEl.getBoundingClientRect();
        if (y <= height) {
          body.classList.add(`--${suffix}-scroll-out`);
        } else {
          body.classList.remove(`--${suffix}-scroll-out`);
        }
      }
    }

    if (hideClass) {
      const atBottom =
        window.innerHeight + window.scrollY >= document.body.offsetHeight;
      if (atBottom) {
        body.classList.add(`--${suffix}-scroll-out`);
      }
    }
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      evaluateScroll();
      ticking = false;
    });
  };

  window.addEventListener("scroll", onScroll, { passive: true });
  evaluateScroll();
};

export { stickyContent as default };
